import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

import type { WebWidgetModel } from '@web/types';

import { type WidgetGroup, isCourseWidget } from '@web/core/constants/widget-groups.const';

/**
 * Splits a widget-picker list into its labelled groups. Pure pipe, so it only
 * re-runs when the source array reference (or the `group` argument) changes —
 * safe to use twice on the same list (`'common'` + `'course'`) without extra
 * subscriptions or per-CD array churn.
 */
@Pipe({ name: 'webWidgetGroup' })
export class WebWidgetGroupPipe implements PipeTransform {
    transform(widgets: WebWidgetModel[] | null | undefined, group: WidgetGroup): WebWidgetModel[] {
        if (!Array.isArray(widgets)) {
            return [];
        }

        return widgets.filter((widget) =>
            group === 'course' ? isCourseWidget(widget.name) : !isCourseWidget(widget.name)
        );
    }
}
